/** @format */
import { produce } from 'immer';

export function appReducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_DRAWER': {
      return produce(state, (draftState) => {
        draftState.isDrawerOpen = !draftState.isDrawerOpen;
      });
    }
    case 'UPDATE_THEME': {
      return produce(state, (draftState) => {
        draftState.activeTheme = action.payload;
      });
    }
    case 'APP_FILTER': {
      const { name, value } = action.payload;
      return produce(state, (draftState) => {
        draftState.appFilters[name] = value;
      });
    }
      
    case 'PAGE_LAYOUT': {
      const { pageName, value } = action.payload;
      return produce(state, (draftState) => {
        draftState.layouts[pageName] = value;
      });
    }

    case 'BATCH_APP_FILTER': {
      // payload: { filters: { PARAMETER: {...}, DATERANGE: {...}, ... } }
      const { filters } = action.payload;
      return produce(state, (draftState) => {
        Object.entries(filters).forEach(([key, value]) => {
          draftState.appFilters[key] = value;
        });
      });
    }

    case 'FLT_SETTING': {
      const { value, name } = action.payload;
      return produce(state, (draftState) => {
        draftState[name] = value;
      });
    }

    case 'USER_INFO': {
      return produce(state, (draftState) => {
        draftState.userInfo = action.payload;
      });
    }
    case 'ATTR_NAMES': {
      return produce(state, (draftState) => {
        draftState.attributeNames = action.payload;
      });
    }
  }
  return state;
}
